import { render, staticRenderFns } from "./TransferInventoryToProjectModal.vue?vue&type=template&id=902fff60"
import script from "./TransferInventoryToProjectModal.vue?vue&type=script&lang=js"
export * from "./TransferInventoryToProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports